import { Skeleton } from '../progress';

export function TableControl() {
  return (
    <div className="mt-2 flex gap-x-3">
      <Skeleton className="h-8 w-72" />
      <Skeleton className="h-8 w-24" />
      <Skeleton className="ml-auto h-8 w-24" />
    </div>
  );
}
